// Generated from SVG to Code Figma Plugin

import type { JSX } from 'react';

export const AngleRight = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.0607 12.0001L11.0304 6.96973L9.96973 8.03039L13.9394 12.0001L9.96973 15.9697L11.0304 17.0304L16.0607 12.0001Z"
      fill="currentColor"
    />
  </svg>
);
